import ErrorOutlined from '@mui/icons-material/ErrorOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import TaskAltOutlined from '@mui/icons-material/TaskAltOutlined';
import WarningOutlined from '@mui/icons-material/WarningOutlined';
import { AlertProps, Box, BoxProps } from '@mui/material';
import ErrorMessages from './error-messages/error-messages.component';

const severityIconMap = {
  success: TaskAltOutlined,
  error: ErrorOutlined,
  warning: WarningOutlined,
  info: InfoOutlined,
};

export type IncFormHelperTextProps = {
  error?: any;
  helperText?: React.ReactNode;
  severity?: AlertProps['severity'];
  BoxProps?: BoxProps;
  'data-testid'?: string;
};

export const IncFormHelperText = ({
  error,
  helperText,
  severity,
  BoxProps,
  'data-testid': testId,
  ...rest
}: IncFormHelperTextProps) => {
  if (!error && !helperText) return null;

  const Icon = severityIconMap[severity];

  return (
    <>
      {helperText && (
        <Box
          display="flex"
          alignItems="flex-start"
          data-testid={testId ?? 'IncFormHelperText.HelperText'}
          {...BoxProps}
          {...rest}
          sx={{ color: 'text.secondary' }}
        >
          {severity && (
            <Icon
              color={severity}
              sx={{ mr: '4px', mt: '2px', fontSize: '16px' }}
            />
          )}
          {helperText}
        </Box>
      )}
      {error && (
        <Box
          display="flex"
          alignItems="flex-start"
          data-testid={testId ? `${testId}.Error` : 'IncFormHelperText.Error'}
          {...BoxProps}
          {...rest}
        >
          <ErrorMessages error={error} />
        </Box>
      )}
    </>
  );
};
export default IncFormHelperText;
